import { render } from "./TournamentWinner.vue?vue&type=template&id=5925a210"
import script from "./TournamentWinner.vue?vue&type=script&lang=js"
export * from "./TournamentWinner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__